import { Box } from '@blockanalitica/ui';
import Modal from '../Modal/Modal';
import { QuestionIcon } from '@/components';
import { ReactNode, useState } from 'react';
import styled from 'styled-components';

export type ModalInfoProps = {
  title?: ReactNode;
  iconSize?: string | number;
  children: ReactNode;
};

const StyledQuestionIcon = styled(QuestionIcon)`
  &:hover {
    cursor: pointer;
  }
`;

export default function ModalInfo({
  title,
  iconSize = '1',
  children
}: ModalInfoProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <StyledQuestionIcon
        onClick={() => setIsModalOpen(true)}
        size={iconSize}
      />
      <Modal
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
        title={typeof title === 'string' ? title : undefined}>
        <Box>{children}</Box>
      </Modal>
    </>
  );
}
